module.exports = __webpack_public_path__ + "static/media/premium-tag.ff20e846.png";